import { Options, Vue } from "vue-class-component";
import DeclineAttentionPopup from "@/dashboard/my-orders/new-popup/decline-attention-popup/decline-attention-popup.vue";
import DeclinePopup from "@/dashboard/my-orders/new-popup/decline-popup/decline-popup.vue";
import { Emit, Model, Prop } from "vue-property-decorator";
import { APIResponse } from "@/shared/api-contract/api-contract";
import { appAxios } from "@/core/utils/appAxios";

@Options({
    components: {
        DeclineAttentionPopup,
        DeclinePopup,
    },
})
export class DeclineDialog extends Vue {
    @Model("_declineOrderIds", { required: true })
    declineOrderIds!: number[];

    isConfirmedDecline = false;
    queryText = "";
    get isShowDecline() {
        return this.declineOrderIds?.length && !this.isConfirmedDecline;
    }
    get isShowAttentionDecline() {
        return this.declineOrderIds?.length && this.isConfirmedDecline;
    }
    @Emit("closeDecline")
    closeDecline() {
        this.isConfirmedDecline = false;
        this.$emit("closeDecline");
    }
    confirmDecline(queryText: string) {
        this.isConfirmedDecline = true;
        this.queryText = queryText;
    }
    async confirmAttentionDecline() {
        await Promise.all(
            this.declineOrderIds.map((id) => {
                this.fetchDeclineOrder(id, this.queryText);
            }),
        );
        this.$emit("closeDecline");
    }
    /* API Connectivity --------------------------------------------------------------------------------------------- */
    fetchDeclineOrder = async (id, reason) => {
        appAxios.value
            .post<APIResponse<void>>(`/client/web/orders/${id}/decline`, { reason })
            // .then()
            .catch((res) => console.log(`Fetch Decline Order #${id} error:`, res));
    };
}
